export default __webpack_public_path__ + "static/studio-slider-12-d6a1436520d1ae0846688fe39f81cd7b.png";